<ng-container>
  <div [ngClass]="{'card card-accent-primary': parsedConfig.showContainer}">
    <form class="horizontal-form" [formGroup]="form" (ngSubmit)="submit()">
      <div class="card-body">
        @if (showFormInvalid()) {
          <div class="alert alert-danger" role="alert">
            <i class="fa fa-lg fa-warning"></i>
            {{
              form.errors.global ||
                'An error occurred after submitting the form.'
            }}
          </div>
        }
        @if (parsedConfig.showDomainInput) {
          <div class="mb-3 row">
            <label
              for="domain"
              class="col-md-2 col-form-label"
              data-cy="label-domain"
              >Domain</label
            >
            <div class="col">
              <ng-container>
                <domain-selector
                  id="domain"
                  [attr.data-cy-value]="form.get('domain').value"
                  class="form-control-holder"
                  [class.is-invalid]="showFieldInvalid('domain')"
                  [formGroup]="form"
                  [formControlName]="'domain'"
                  [placeholder]="'Select domain'"></domain-selector>
                @if (showFieldInvalid('domain')) {
                  <div class="invalid-feedback">Please select a domain.</div>
                }
              </ng-container>
            </div>
          </div>
        }
        <div class="mb-3 row">
          <label
            for="username"
            class="col-md-2 col-form-label"
            data-cy="label-username"
            >Username</label
          >
          <div class="col">
            <input
              id="username"
              type="text"
              class="col"
              [attr.data-cy-value]="form.get('username').value"
              [ngClass]="'form-control'"
              placeholder="Username"
              [class.is-invalid]="showFieldInvalid('username')"
              formControlName="username"
              required />
            @if (showFieldInvalid('username')) {
              <div class="invalid-feedback">Please enter a username.</div>
            }
          </div>
        </div>
        <div class="mb-3 row">
          <label
            for="emailAddress"
            class="col-md-2 col-form-label"
            data-cy="label-email"
            >E-mail address</label
          >
          <div class="col">
            <input
              id="emailAddress"
              type="text"
              class="col"
              [attr.data-cy-value]="form.get('emailAddress').value"
              [ngClass]="'form-control'"
              placeholder="E-mail address"
              [class.is-invalid]="showFieldInvalid('emailAddress')"
              formControlName="emailAddress"
              required />
            @if (showFieldInvalid('emailAddress')) {
              <div class="invalid-feedback">
                Please enter a valid e-mail address.
              </div>
            }
            @if (nonEligibleEmail) {
              <div
                class="invalid-feedback is-invalid"
                style="display: block !important">
                Only users within the payter organisation are allowed to be
                created on PAYTER or CURO domains.
              </div>
            }
          </div>
        </div>
        <!-- 2FA is enrolled by the backend, never by this form. Shown so the
             state is visible, always disabled. -->
        <div class="mb-3 row">
          <label for="mfa" class="col-md-2 col-form-label" data-cy="label-mfa"
            >Two-factor authentication</label
          >
          <div class="col d-flex align-items-center gap-2">
            <label class="switch switch-3d switch-primary mb-0">
              <input
                type="checkbox"
                id="mfa"
                class="switch-input"
                [attr.data-cy-value]="form.get('mfa').value"
                formControlName="mfa" />
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
            <span class="text-muted small">
              Managed by the backend, enrolled after the account exists.
            </span>
          </div>
        </div>

        <div class="mb-3 row">
          <label
            for="roles"
            class="col-md-2 col-form-label"
            data-cy="label-role-selector"
            >Roles</label
          >
          <div class="col">
            <role-selector
              id="roles"
              [attr.data-cy-value]="form.get('roles').value"
              [formGroup]="form"
              [domain]="domain.value"
              formControlName="roles"></role-selector>
          </div>
        </div>
        <!-- <div class="mb-3 row">
            <label for="myPayterBeta" class="col-md-2 col-form-label"
              >MyPayter Customer Portal</label
              >
              <div class="col">
                <label class="switch switch-3d switch-primary">
                  <input type="checkbox" class="switch-input beta-portal-toggle" formControlName="myPayterBeta" [attr.data-cy-value]="form.get('myPayterBeta').value">
                  <span class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
              </div>
            </div> -->
      </div>
      @if (parsedConfig.showButtons) {
        <div class="card-footer">
          <div class="form-submit">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="
                form.invalid ||
                submitting ||
                !hasAtleastOneCheckboxChecked ||
                nonEligibleEmail
              ">
              <span
                (click)="submitHelper($event)"
                (keydown.enter)="submitHelper($event)"
                ><i class="fa fa-check">&nbsp;</i>Submit</span
              >
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              (click)="reset()"
              (keydown.enter)="reset()">
              <i class="fa fa-ban"></i> Reset
            </button>
          </div>
        </div>
      }
    </form>
  </div>
</ng-container>
